export const STOCK_TRANSPORT_ORDER_VI = {
  number: 'Mã đơn hàng luân chuyển',
  title: 'Quản lý đơn hàng luân chuyển',
  titleDetail: 'Chi tiết đơn hàng luân chuyển',
  createStockTO: 'Tạo đơn hàng luân chuyển',
  all: 'Tất cả',
  created: 'Mới',
  rejected: 'Đã từ chối',
  awaiting_logistic: 'Chờ vận chuyển',
  awaiting_inbound: 'Chờ nhập hàng',
  inbounded: 'Đã nhập hàng',
  stockTransportQuantity: 'Số lượng luân chuyển',
}
